import { Translate } from '@ff-os/shared-utils/types/Translate';
import { Placeholder } from './Placeholder';
import { textPositionOf } from './textPositionOfPlaceholder';

export const addText = (
    ctx: CanvasRenderingContext2D,
    t: Translate,
    width: number,
    height: number,
    scaledFontSize: number,
    placeholder?: Placeholder
) => {

    const placeholderFirstLine = t('photo_placeholder.first_line');
    const placeholderSecondLine = t('photo_placeholder.second_line');

    const largestSide = Math.max(width, height);
    const fontSize = scaledFontSize || Math.floor(0.15 * largestSide);

    ctx.fillStyle = 'rgba(0, 0, 0, 0.4)';
    ctx.font = `900 ${fontSize}px Nunito`;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';

    const textPosition = textPositionOf(placeholder, width, height);
    ctx.fillText(placeholderFirstLine, textPosition.x, textPosition.upperY);
    ctx.fillText(placeholderSecondLine, textPosition.x, textPosition.lowerY);
};